import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Nebraska = () => {
  return (
    <StatePropertyTaxPage
      stateName="Nebraska"
      processDescription="Property owners may protest their assessment by filing with the county board of equalization. Protests must be filed within the specified timeframe and should include evidence supporting the property owner's valuation."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in May to allow time for the protest and equalization process."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Nebraska assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year."
      deadlineExplanation="Property owners typically have 30 days from the notice mailing date to file protests with the county board of equalization. The deadline usually falls in June."
    />
  );
};

export default Nebraska;